import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ChevronRightIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.21623 20.3143C8.82571 19.9237 8.82571 19.2906 9.21623 18.9L15.5091 12.6071L9.21623 6.31425C8.82571 5.92373 8.82571 5.29056 9.21623 4.90004C9.60676 4.50952 10.2399 4.50952 10.6304 4.90004L17.6304 11.9C18.021 12.2906 18.021 12.9237 17.6304 13.3143L10.6304 20.3143C10.2399 20.7048 9.60676 20.7048 9.21623 20.3143Z"
            />
        </SvgIcon>
    );
};

export default ChevronRightIcon;
